/*
This file is located in the main branch
Last time the file was updated (UTC): [02.07.2024 18:52:59]
Permissions to update outside the main branch: [false]
*/

import { DropdownFilterButton } from '@finbeat/react-toolkit';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { useDeclinedShowcasesWorkplaceState } from './DeclinedShowcases';

type DeclinedShowcaseAddButtonProps = {
    showModal: () => void;
};

const DeclinedShowcaseAddButton = ({ showModal }: DeclinedShowcaseAddButtonProps) => {
    const { setSelectedItem: setCurrentItem } = useDeclinedShowcasesWorkplaceState();

    return (
        <DropdownFilterButton
            onClick={() => {
                setCurrentItem(null);
                showModal();
            }}
            icon={faPlus}
            disabled={false}
            title="BackOfficeAdd"
        />
    );
};

export default DeclinedShowcaseAddButton;
